
import Banner from "../components/Banner.vue";
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import axios from "axios";

export default defineComponent({
  components: { Banner },
  setup() {
    const state = reactive({
      monsters: Array,
      monsterDetails: Array,
      monsterActions: [],
      monster: "",
    });

    onMounted(async () => {
      const { data } = await axios.get("https://www.dnd5eapi.co/api/monsters");
      state.monsters = data.results;
    });

    function showCards() {
      var element = document.getElementById("monster-cards");
      element!.classList.remove("hidden");
    }

    const showMonster = async (index: string) => {
      const { data } = await axios.get(
        `https://www.dnd5eapi.co/api/monsters/${index}`
      );
      state.monsterDetails = data;
      state.monsterActions = data.actions;
    };

    const searchMonster = async () => {
      const { data } = await axios.get(
        `https://www.dnd5eapi.co/api/monsters/${state.monster.toLowerCase()}`
      );
      state.monsterDetails = data;
      state.monsterActions = data.actions;
    };

    return { ...toRefs(state), showCards, showMonster, searchMonster };
  },
});
